module.exports = __webpack_public_path__ + "img/logo2.7e8db29b.png";